import { render, staticRenderFns } from "./BikeForm.vue?vue&type=template&id=6d5d5fce&"
import script from "./BikeForm.vue?vue&type=script&lang=js&"
export * from "./BikeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BikeForm.vue"
export default component.exports